import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Container, Row, Col, Modal, Spinner, Form, Button, Card } from "react-bootstrap";
import Select from 'react-select';
import empresas from 'api/empresas';
import { AccountContext } from 'components/Account/Account';
import consultaFolio from 'api/consultaFolio';

const ConsultaEstadoFolio = () => {
    const { getSession } = useContext(AccountContext);

    const [empresa, setEmpresa] = useState('');
    const [empresaList, setEmpresaList] = useState([]);
    const [folio, setFolio] = useState('');
    const [tipodocumento, setTipodocumento] = useState(39);
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [codigo, setCodigo] = useState('');
    const [descripcion, setDescripcion] = useState('');

    const handleClose = () => {
        setShow(false);
        setFolio('');
        setCodigo('');
        setDescripcion('');
        setMessage('');
    };

    const options = useMemo(() =>
        empresaList
            .filter((e) => e.rut != 1)
            .map((e) => ({ value: e.rut, label: `${e.rut} - ${e.name}` })),
        [empresaList]
    );
    const optionsdoc = [
        { value: '33', label: '33' },
        { value: '39', label: '39' },
        { value: 41, label: '41' },
    ];

    const handleSelectChange = (e) => setEmpresa(e.value);
    const handleFolioChange = (e) => setFolio(e.target.value);
    const handletipodocumentoChange = (e) => setTipodocumento(e.value);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setCodigo('');
        setDescripcion('');
        setMessage('');

        if (empresa === '') {
            setMessage('Por favor seleccione una empresa');
            setLoading(false);
            setShow(true);
            return;
        }
        if (folio === '') {
            setMessage('Por favor escriba un número de folio');
            setLoading(false);
            setShow(true);
            return;
        }

        setLoading(true);
        setShow(true);

        const rut = empresa;
        const params = { rut, folio, tipodocumento };
        const idToken = await getSession().then((session) => session.idToken.jwtToken);
        try {
            const resp = await consultaFolio(params, idToken);
            setCodigo(resp.codigo ?? '');
            setDescripcion(resp.descripcion ?? '');
            setLoading(false);
        } catch (error) {
            setMessage('Error al consultar el folio');
            setLoading(false);
        }
    };

    useEffect(() => {
        getSession().then((session) => {
            empresas.getEmpresas(session.idToken.jwtToken)
                .then((response) => setEmpresaList(response.data))
                .catch((error) => console.log(error));
        });
    }, []);

    const estadoVariant = (desc) => {
        if (!desc) return 'info';
        const text = desc.toString().toLowerCase();
        // Estados negativos primero: "no recibido" contiene "recibido", así que
        // debe evaluarse antes que el caso de éxito para no pintarse de verde.
        if (text.includes('no recib') || text.includes('no recep') || text.includes('rechaz') || text.includes('error') || text.includes('anulad')) return 'danger';
        if (text.includes('pendi') || text.includes('reparo') || text.includes('observ')) return 'warning';
        if (text.includes('aceptado') || text.includes('recibido') || text.includes('ok') || text.includes('disponible')) return 'success';
        return 'info';
    };

    return (
        <>
            <Container fluid className="page-container">
                <div className="page-header">
                    <div>
                        <h2 className="page-title">Consulta Folios</h2>
                        <p className="page-subtitle">Consulta el estado de un folio por empresa y tipo de documento.</p>
                    </div>
                </div>

                <Card className="data-card">
                    <Card.Body>
                        <Form onSubmit={handleSubmit} className="filter-form">
                            <Row>
                                <Col xs={12} md={6} lg={5}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Empresa</Form.Label>
                                        <Select
                                            options={options}
                                            onChange={handleSelectChange}
                                            placeholder="Selecciona una empresa..."
                                            classNamePrefix="rs"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6} lg={3}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Folio</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={folio}
                                            onChange={handleFolioChange}
                                            placeholder="N° de folio"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} md={6} lg={2}>
                                    <Form.Group className="form-field">
                                        <Form.Label>Tipo de documento</Form.Label>
                                        <Select
                                            options={optionsdoc}
                                            defaultValue={{ value: '39', label: '39' }}
                                            onChange={handletipodocumentoChange}
                                            classNamePrefix="rs"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col xs={12} lg={2} className="d-flex align-items-end form-actions">
                                    <Button type="submit" className="btn-primary-action">
                                        <i className="nc-icon nc-zoom-split" />
                                        Consultar
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>

            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Estado del folio</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? (
                        <div className="result-loading">
                            <Spinner animation="border" role="status" />
                            <span>Consultando folio...</span>
                        </div>
                    ) : message ? (
                        <div className="result-error">{message}</div>
                    ) : (
                        <div className="result-grid">
                            <div className="result-grid__header">
                                <span className="result-grid__folio-label">Folio</span>
                                <span className="result-grid__folio-value">{folio}</span>
                                {descripcion && (
                                    <span className={`status-badge status-badge--${estadoVariant(descripcion)}`}>
                                        {descripcion}
                                    </span>
                                )}
                            </div>
                            {codigo !== '' && (
                                <div className="result-grid__row">
                                    <span className="result-grid__label">Código</span>
                                    <span className="result-grid__value">{codigo}</span>
                                </div>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default ConsultaEstadoFolio;
